import axios from "axios";

export const requestTipPaymentVerification = async (purchaseID: string) => {
  try {
    const response = await axios.post(
      `v1/tips/web/purchases/${purchaseID}/confirm`
    );
    if (response) return response;
  } catch (e: any) {
    return e;
  }
};
export const requestTipPaymentIntent = (payload: any): Promise<any> =>
  axios.post("v1/tips/web/purchases", payload.toJSON());
